import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LocalizeRouterService } from '@app/i18n';
import { SKIP_ERROR_HANDLER } from '../http-context';

export const apiErrorInterceptor: HttpInterceptorFn = (request, next) => {
    if (request.context.get(SKIP_ERROR_HANDLER)) {
        return next(request);
    }

    const router = inject(Router);
    const localizeRouterService = inject(LocalizeRouterService);

    return next(request).pipe(
        catchError((response: HttpErrorResponse) => {
            if (response.status === 404 || response.status === 403) {
                void router.navigate(localizeRouterService.translateRoute(['/not-found']), {
                    skipLocationChange: true,
                });
            }

            return throwError(() => response);
        }),
    );
};
